"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import { useState, useId, useRef, useEffect } from 'react';
import 'invariant';
import 'luxon';
import 'react-aria-components';
import 'clsx';
import '../../../../../../../lib/propsContext/propsContext.mjs';
import '../../../../../../../lib/viewComponentContext/viewComponentContext.mjs';
import { dynamic } from '../../../../../../../lib/propsContext/dynamicProps/dynamic.mjs';
import { PropsContextProvider } from '../../../../../../../lib/propsContext/PropsContextProvider.mjs';
import '@tabler/icons-react';
import '../../../../../../Icon/Icon.mjs';
import '../../../../../../Heading/Heading.mjs';
import '../../../../../../Text/Text.mjs';
import 'react-aria';
import '@mittwald/react-tunnel';
import '../../../../../../Button/Button.mjs';
import '../../../../../../ContextMenu/ContextMenu.mjs';
import '../../../../../../MenuItem/MenuItem.mjs';
import '../../../../../../ContextMenu/components/ContextMenuTrigger/ContextMenuTrigger.mjs';
import '../../../../../../ContextMenu/components/ContextMenuSection/ContextMenuSection.mjs';
import '../../../../../../ColumnLayout/ColumnLayout.mjs';
import '../../../../ListSummary/ListSummary.mjs';
import { useList } from '../../../../../hooks/useList.mjs';
import '../../../../../List.mjs';
import { AccordionButton } from '../components/AccordionButton.mjs';

const useGridItemProps = (props) => {
  const { data, children: childrenFromProps } = props;
  const list = useList();
  const itemView = list.itemView;
  const onAction = list.onAction;
  const [isExpanded, setIsExpanded] = useState(
    itemView?.defaultExpanded?.(data) ?? false
  );
  const contentElementId = useId();
  const itemRef = useRef(null);
  const accordion = list.accordion;
  const children = childrenFromProps ?? itemView?.render(data);
  useEffect(() => {
    if (accordion) {
      itemRef.current?.setAttribute("aria-expanded", String(isExpanded));
      itemRef.current?.setAttribute("aria-controls", contentElementId);
    }
  }, [isExpanded, contentElementId, itemRef.current, accordion]);
  if (!accordion) {
    return {
      gridItemProps: {
        onAction: onAction ? () => {
          onAction?.(data);
        } : void 0
      },
      children
    };
  }
  const toggleAccordion = () => {
    setIsExpanded((current) => !current);
    onAction?.(data);
  };
  const propsContext = {
    Content: {
      id: dynamic((p) => p.slot === "bottom" ? contentElementId : void 0),
      wrapWith: dynamic(
        (p) => p.slot === "bottom" ? /* @__PURE__ */ jsx(
          AccordionButton,
          {
            contentElementId,
            toggle: toggleAccordion,
            isExpanded
          }
        ) : void 0
      )
    }
  };
  return {
    gridItemProps: {
      ref: itemRef,
      onAction: toggleAccordion
    },
    children: /* @__PURE__ */ jsx(
      PropsContextProvider,
      {
        props: propsContext,
        dependencies: [contentElementId, isExpanded],
        children
      }
    )
  };
};

export { useGridItemProps };
//# sourceMappingURL=useGridItemProps.mjs.map
